import { render, staticRenderFns } from "./UnavailablePeriodForm.vue?vue&type=template&id=354990ca"
import script from "./UnavailablePeriodForm.vue?vue&type=script&lang=ts"
export * from "./UnavailablePeriodForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports